"use strict";
var Observable_1 = require('../../Observable');
var mergeMap_1 = require('../../operator/mergeMap');
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/mergeMap.js
 ** module id = 1208
 ** module chunks = 0
 **/